// extracted by mini-css-extract-plugin
module.exports = {"submitErrorList":"TabGroupedErrors-submitErrorList-1tfUvU","submitErrorTabTitle":"TabGroupedErrors-submitErrorTabTitle-2brGuB"};